import {Component, HostBinding, Input} from '@angular/core';
import {MenuItem} from '@catui/types';

const componentBaseName = 'popup-menu';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-popup-menu',
  templateUrl: './popup-menu.component.html',
})
export class PopupMenuComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() model: MenuItem[];

  constructor() {
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/popup-menu/popup-menu.component.ts